var lang={SUN:"日",MON:"一",TUE:"二",WED:"三",THU:"四",FRI:"五",SAT:"六",Month:["一","二","三","四","五","六","七","八","九","十","十一","十二"]};module.exports=lang;


// WEBPACK FOOTER //
// ./~/wasabiD/Lang/zh-cn.js